<template>
  <div class="praise">
    <div class="container banner">
      <img src="../../static/img/about/banner.png" style="width: 100%;margin-bottom: 60px;" alt="">
      <div class="content">
        <div class="bread">
          您现在的位置：
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item >合美特色</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <h3 class="meal-title"><span class="title-line"></span>阶段式科学坐月子<span class="title-line"></span></h3>
        <div class="phase">
          <div class="phase-item" v-for="item in phaseL" :key="item.id">
            <img :src="item.src" class="phase-img" alt="">
            <p class="phase-title">{{item.title}}</p>
            <div class="phase-cont">{{item.cont}}</div>
          </div>
        </div>
        <h3 class="meal-title"><span class="title-line"></span>N对1、1对1的24h专属照护<span class="title-line"></span></h3>
        <div class="content-a">
          <p class="cate-title">合美具备完整的孕、产、护、教完整育儿体系</p>
          <div class="cate-cont">N对1是由由一位经严格专业培训的母婴专护师，会同具备丰富临床经验的妇、产、儿、心理、营养、保健等学科专家和资深护理人员组成的专家团队，制定月子健康护理计划，定期巡检时刻调整月子计划，每日查房进行专业照护。</div>
          <p class="cate-title">1对1提供专业优质月嫂，照顾妈妈生活起居；</p>
          <div class="cate-cont">合美提倡母婴同室培养感情，同时夜间宝宝护理室也配备母婴专护师，可提供宝宝照顾服务，确保妈妈修养身体；医护人员24小时值班，提供保健指导与紧急治疗，确保母婴健康与安全。</div>
        </div>
        <h3 class="meal-title"><span class="title-line"></span>个性化定制台式科学月子餐<span class="title-line"></span></h3>
        <div class="content-a">
          <img  class="banner-con" src="../../static/img/advantage/banner-1.png" alt="">
          <p class="cate-title">什么是台式月子餐</p>
          <div class="cate-cont">引进台式月子餐，采取“一清、二调、三补、四强化”的食疗原则：保证一日三餐主食+三次点心，300样菜确保28天不重复，并分阶段进行，打破月子餐传统误区，科学搭配膳食，营养均衡，采用药食同源的方式为妈妈们量身定制月子餐，让妈妈们吃出美丽，吃出健康</div>
          <div class="flex-box">
            <div class="sp-per" v-for="item in mealL" :key="item.id">
              <img class="sp-img" :src="item.src" alt="">
              <div class="sp-cont" v-html="item.cont"></div>
            </div>
          </div>
          <div class="flex-box">
            <div class="meal-per" v-for="item in mealLB" :key="item.id">
              <img class="meal-img" :src="item.src" alt="">
              <p class="meal-name">{{item.title}}</p>
              <div class="meal-cont" v-html="item.cont"></div>
            </div>
          </div>
          <p class="cate-title">合美台式月子餐特色</p>
          <div class="cate-cont">
            合美台式月子膳食特色以医疗月子调理为特色。由专业营养师及台湾著名月子餐药膳调理讲师陈和扬等组成的母婴保健营养团队（曾为昆凌等明星妈妈定制膳食，擅长调理产后气血衰弱，按照春夏秋冬不同季节搭配药膳）以中西医学理论为基础、保留中华传统月子文化，总结出适合中国人体质产后饮食方法——以产妇体质设定药膳汤，以产妇产前体重设定总能量，以产妇各项检查指标定每餐的食谱，保证产后妈妈奶水增加，体重恢复，做到真正科学月子膳食。
<br><br>
            药膳汤全部采用台湾顶级进口药材，进口水，月子餐的食材全都采用有机食材，我们有专门的种植基地，保证食材绿色健康，力求为妈妈们提供最健康营养的月子膳食
          </div>
          <h3 class="meal-title"><span class="title-line"></span>合美韩式无痛开奶<span class="title-line"></span></h3>
          <img  class="banner-con" src="../../static/img/advantage/banner-2.png" alt="">
          <p class="cate-title">什么是韩式无痛开奶</p>
          <div class="cate-cont">合美韩式无痛乳房管理是结合多年研究创新开展的一套综合性独特开奶、乳房疾病管理方法，通过对通过对组织和穴位进行轻柔和按摩，促进血液循环，有助于充分增加泌乳并且缓解乳房疼痛现象，让妈妈们享受月子生活。主要特色是与传统开奶最大的区别就说乳房管理的无痛感，让宝宝第一时间喝到妈妈的母乳，解决喂养问题 。</div>
          <p class="cate-title">合美韩式无痛开奶</p>
          <div class="cate-cont">协助开奶、产后胀奶、 乳汁淤积、产后无乳、乳少、缺乳、拘奶（乳腺炎）、乳头扁平或乳头凹陷、气奶而导致的乳汁分泌不畅。堵奶、乳汁淤积当场见效。催乳师收费标准需要根据宝妈的情况和服务区域确定。</div>
          <p class="cate-title">合美特色服务——母乳指导</p>
          <div class="cate-cont">向孕妈妈和新妈妈普及母乳喂养的相关知识，让孕妈妈提前知晓好的开奶如何做, 用通俗的语言向您阐述泌乳原理, 指导产妇在产后让孩子吃好第一口奶, 避免乳头混淆问题的发生, 指导新妈妈解决生理性乳胀、乳头皲裂、乳晕周围损伤、乳腺炎等问题。</div>
          <h3 class="meal-title"><span class="title-line"></span>合美“纤之韵”产后修复<span class="title-line"></span></h3>
          <img  class="banner-con" src="../../static/img/advantage/banner-3.png" alt="">
          <p class="cate-title">为什么要做产后修复</p>
          <div class="cate-cont">经过孕产，妈妈们身体经受巨大考验，也存在许多隐形问题。比如尿失禁、阴道松弛、子宫下垂、耻骨分离、盆骨前倾等现象。而这些问题往往在产后1年或多年后才发现。产后修复将精准预防和控制这些疾病的发生。</div>
          <p class="cate-title">“纤之韵”产后修复</p>
          <div class="cate-cont">合美与北京和睦家产康出诊专家张晓东博士合作，特邀其他产康专家定期坐诊为孕妈提供顶级专业的医护团队。张晓东博士作为留美医学博士、和睦家产康专家、中美职业资质医师为国内外数位明星妈妈提供产康解决方案。张博士擅长中西医结合产后康复治疗，运用美国Thompson技术，将理疗、整骨、胶原蛋白导入相结合，再通过理疗和专业整骨手法，让骨盆恢复其自然生理机能，彻底为孕妈深度剖析解决问题。
          <br><br>
            合美“纤之韵”产康团队将依靠专业医疗保障，除常规的骨伤康复和脊柱康复，提供包括臀部恢复、盆骨矫正、盆骨肌腹直肌修复、肚子恢复、淋巴排毒等专业产后恢复服务。</div>
          <h3 class="meal-title"><span class="title-line"></span>印尼古法+JAM科技新创纤体塑形<span class="title-line"></span></h3>
          <img  class="banner-con" src="../../static/img/advantage/banner-4.png" alt="">
          <div class="cate-cont">合美与北京和睦家产康出诊专家张晓东博士合作，特邀其他产康专家定期坐诊为孕妈提供顶级专业的医护团队。张晓东博士作为留美医学博士、和睦家产康专家、中美职业资质医师为国内外数位明星妈妈提供产康解决方案。张博士擅长中西医结合产后康复治疗，运用美国Thompson技术，将理疗、整骨、胶原蛋白导入相结合，再通过理疗和专业整骨手法，让骨盆恢复其自然生理机能，彻底为孕妈深度剖析解决问题。
            <br><br>
            通常产后腹部的皮肤被过度伸张松弛，腹肌被拉长，内脏移位，导致腰腹部脂肪堆积
            <br><br>
            秉承管家服务理念，提供快捷周到的个性化服务入馆母婴健康体检，对产妇及婴儿进行健康评估。采取人工与机器结合，前期脆弱期按摩医护人员进行按摩，两个月后利用国际顶尖仪器，配备专业的产后顾问，进行体质分析；提供月子身体恢复计划制定、瘦身计划制定服务。
            <br><br>
            合美产后专业形体修复以专业按摩手法，是运用独特的淋巴手法汲取传统中医精粹，用中医点穴配合塑腹技巧，使变大变松的脂肪粒压缩变小变实，增加弹性纤维的韧性以及表皮的弹性，做到分解脂肪排出毒素和多余水分，最使腰部结实；独特的塑腹技巧在印尼古法基础上依据产后妈妈身体结构设计改良，排出腹部毒素、帮助子宫收缩、子宫修复、同时修复腹直肌与盆底肌，紧致塑形，配合合美主打的JAMU和CHIMU这款产后修复的黑科技，将帮助新妈妈快速恢复，完美塑形，重归自信。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "advantage",
    data(){
      return{
        phaseL:[
          {
            id:1,
            src:'../../static/img/advantage/phase-1.png',
            title:'第一阶段（7天）脆弱期：宝宝好安全，妈妈好舒心',
            cont:'护理上合美特色韩式无痛开奶，解决全母乳喂养问题。另一方面主要是要把多余的水分和毒素以及恶露排出体外，护理伤口。餐食上首选健脾利水、理气除湿、养血祛风、润燥通便的食材，多以蒸、炖、烩等烹饪方式为主，清淡少油，松软可口，为产妇身体复元、催生乳汁打下基础；后期选用多种含有丰富蛋白质、氨基酸的珍贵鱼类、及富含维生素、莲子等食材共同烹制，辩证施补，强化因哺乳流失的钙质及营养补充。'
          },
          {
            id:2,
            src:'../../static/img/advantage/phase-2.png',
            title:'第二阶段（14天）过渡期：宝宝好身体，妈妈好恢复',
            cont:'护理上主要配合宝宝生物钟调理合妈妈体制恢复，增强骨质和腰肾的功能。餐食上此阶段处于身体复元的关键时期，食物选以营养高能、富含胶原蛋白及多种维生素和矿物质的优质海参、雪花牛肉、散养土鸡等入菜，佐以独家烹制方法，使传统膳食在充分保留营养价值的基础上，创新别样的味蕾感受，令产妇在醇香美味的享受中得到能量和营养进补。'
          },
          {
            id:3,
            src:'../../static/img/advantage/phase-3.png',
            title:'第三阶段（7-35天）成熟期：宝宝好聪明，妈妈好美丽',
            cont:'专业医护人员进行宝宝专业测评、私人定制产后恢复计划。主要开始进补身体，进行身体塑形恢复。餐食上多选名贵真菌、龙虾鲍鱼、虫草燕窝等丰富营养食材，口味鲜美，补而不腻，有助产妇消化吸收，并起到清脂排毒、淡斑美白、利水补气、纤体强身的功效；配合适量美体训练，使产妇在月子尾期，增强自身机能，突显康复效果，恢复曼妙身材。'
          },
        ],
        mealL:[
          {
            id:1,
            src:'../../static/img/advantage/text-1.png',
            cont:'排除恶露，消除水肿，强健脾胃，<br>' +
              '促进伤口愈合'
          },
          {
            id:2,
            src:'../../static/img/advantage/text-2.png',
            cont:'滋阴补血，促进乳汁分泌，强健筋骨，<br>' +
              '滑肠通便'
          },
          {
            id:3,
            src:'../../static/img/advantage/text-3.png',
            cont:'补筋骨，强腰膝，清火润肺,安心神，<br>' +
              '补气养血，调理体质'
          },
          {
            id:4,
            src:'../../static/img/advantage/text-4.png',
            cont:'补气补血，改善体质、预防老化,补肾、<br>' +
              '填精养血、进补气血，美容降脂强化'
          },
        ],
        mealLB:[
          {
            id:1,
            src:'../../static/img/advantage/meal-1.png',
            title:'一清',
            cont:'排除恶露，消除水肿，强健脾胃，<br>促进伤口愈合'
          },
          {
            id:2,
            src:'../../static/img/advantage/meal-2.png',
            title:'二调',
            cont:'滋阴补血，促进乳汁分泌，强健筋骨，<br>' +
              '滑肠通便'
          },
          {
            id:3,
            src:'../../static/img/advantage/meal-3.png',
            title:'三补',
            cont:'补筋骨，强腰膝，清火润肺,安心神，<br>补气养血，调理体质'
          },
          {
            id:4,
            src:'../../static/img/advantage/meal-4.png',
            title:'四强化',
            cont:'补气补血，改善体质、预防老化,补肾、<br>' +
              '填精养血、进补气血，美容降脂强化'
          },
        ],
      }
    }
  }
</script>

<style scoped lang="less">
  .praise{
    .content{
      .bread{
        margin-bottom: 20px;
        font-size: 12px;
        color:#999999;
        .el-breadcrumb{
          vertical-align: middle;
          display: inline-block;
          span{
            font-size: 12px;
            color:#999999;
          }
        }
      }
      .meal-title{
        margin-bottom: 50px;
        text-align: center;
        font-size: 28px;
        line-height: 32px;
        font-weight: 500;
        .title-line{
          width: 65px;
          height: 1px;
          margin:0 30px;
          display: inline-block;
          background-color: #cccccc;
          vertical-align: middle;
        }
      }
      .cate-title{
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 6px;
      }
      .cate-cont{
        font-size: 14px;
        color:#666666;
        margin-bottom: 30px;
        line-height: 28px;
      }
      .phase{
        margin-bottom: 40px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .phase-item{
          width: 395px;
          .phase-img{
            width: 100%;
            height: 322px;
            margin-bottom: 20px;
          }
          .phase-title{
            font-size: 14px;
            font-weight: 600;
            margin-bottom: 14px;
          }
          .phase-cont{
            width: 100%;
            color:#666666;
            font-size: 14px;
            line-height: 28px;
          }
        }
      }
      .content-a{
        margin-bottom: 60px;
      }
      .banner-con{
        margin-bottom: 24px;
      }
      .flex-box{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-bottom: 30px;
        .sp-per{
          width: 250px;
          display: flex;
          flex-direction: column;
          align-items: center;
          .sp-img{
            width: 108px;
            height: 108px;
            margin:0 auto 5px;
          }
          .sp-cont{
            text-align: center;
            color:#999999;
            line-height: 22px;
          }
        }
        .meal-per{
          width: 297px;
          display: flex;
          flex-direction: column;
          align-items: center;
          .meal-img{
            margin-bottom: 18px;
            width: 100%;
            height: 240px;
          }
          .meal-name{
            margin-bottom: 4px;
            text-align: center;
          }
          .meal-cont{
            text-align: center;
            color:#999999;
            line-height: 22px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/advantage.vue